import { createSlice } from "@reduxjs/toolkit";
import { firestore } from "../../firebase";
import { collection, getDocs, addDoc, serverTimestamp, doc, updateDoc } from "firebase/firestore";

const initialState = {
  especes: [],
  medicaments: [],
  isLoading: false,
  error: false,
};

export const MedicamentSlice = createSlice({
  name: "medicament",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // GET medicaments
    getMedicamentsSuccess(state, action) {
      state.isLoading = false;
      state.medicaments = action.payload;
    },

    // GET EspeceS
    getEspecesSuccess(state, action) {
      state.isLoading = false;
      state.especes = action.payload;
    },
    // create medicament
    createMedicamentSuccess(state, action) {
      state.medicaments.push(action.payload);
    },
    // update medicament
    updateMedicamentSuccess(state, action) {
      state.medicaments = state.medicaments.map((medicament) => {
        if (medicament.id === action.payload.id) {
          return action.payload;
        }
        return medicament;
      });
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  startLoading,
  hasError,
  getEspecesSuccess,
  getMedicamentsSuccess,
  createMedicamentSuccess,
  updateMedicamentSuccess,
} = MedicamentSlice.actions;

// create medicament function

export const createMedicament = (data) => async (dispatch) => {
  const { name, deseaseID } = data;
  const docRef = collection(firestore, "medicament");
  const newData = {
    name: name,
    deseaseID: deseaseID,
    timestamp: serverTimestamp(),
  };
  try {
    dispatch(startLoading());
    const addedDocRef = await addDoc(docRef, newData);
    const id = addedDocRef.id;
    // Update the document with the ID
    const docToUpdate = doc(firestore, "medicament", id);
    await updateDoc(docToUpdate, { id });
    dispatch(createMedicamentSuccess({ ...newData, id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// get medicaments

export const getMedicaments = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "medicament"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getMedicamentsSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// update medicament

export const updateMedicament = (data) => async (dispatch) => {
  const { id, name, deseaseID } = data;
  const docRef = doc(firestore, "medicament", id);
  try {
    dispatch(startLoading());
    await updateDoc(docRef, { name, deseaseID });
    dispatch(updateMedicamentSuccess({ id, name, deseaseID }));
  } catch (error) {
    dispatch(hasError(error));
  }
};

// get Especes from firestore
export const getEspeces = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "espece"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getEspecesSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};

export default MedicamentSlice.reducer;
